import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, withModifiers as _withModifiers, withCtx as _withCtx } from "vue"

const _hoisted_1 = {
  class: "modal fade",
  id: "kt_modal_trainee_photo_update",
  ref: "addModalRef",
  tabindex: "-1",
  "aria-hidden": "true"
}
const _hoisted_2 = { class: "modal-dialog modal-dialog-centered mw-750px" }
const _hoisted_3 = { class: "modal-content" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("div", {
  class: "modal-header bg-success",
  id: "kt_modal_trainee_photo_update_header"
}, [
  /*#__PURE__*/_createElementVNode("h2", { class: "fw-bolder text-light" }, "Trainee Photo Update"),
  /*#__PURE__*/_createElementVNode("div", {
    id: "kt_modal_trainee_photo_update_close",
    "data-bs-dismiss": "modal",
    class: "btn btn-icon btn-sm btn-active-icon-primary"
  }, [
    /*#__PURE__*/_createElementVNode("i", { class: "fas fa-times text-light" })
  ])
], -1)
const _hoisted_5 = { class: "modal-body py-10 px-lg-17" }
const _hoisted_6 = {
  class: "scroll-y me-n7 pe-7",
  id: "kt_modal_trainee_photo_update_scroll",
  "data-kt-scroll": "true",
  "data-kt-scroll-activate": "{default: false, lg: true}",
  "data-kt-scroll-max-height": "auto",
  "data-kt-scroll-dependencies": "#kt_modal_trainee_photo_update_header",
  "data-kt-scroll-wrappers": "#kt_modal_trainee_photo_update_scroll",
  "data-kt-scroll-offset": "300px"
}
const _hoisted_7 = { class: "col-md-6" }
const _hoisted_8 = /*#__PURE__*/_createElementVNode("label", { class: "fs-6 fw-bold form-label required" }, "Upload From Local Machine", -1)
const _hoisted_9 = { id: "preview" }
const _hoisted_10 = ["src"]
const _hoisted_11 = { class: "modal-footer flex-center" }
const _hoisted_12 = /*#__PURE__*/_createElementVNode("button", {
  type: "reset",
  id: "kt_modal_trainee_photo_update_cancel",
  class: "btn btn-light me-3"
}, " Discard ", -1)
const _hoisted_13 = ["data-kt-indicator"]
const _hoisted_14 = {
  key: 0,
  class: "indicator-label"
}
const _hoisted_15 = { class: "svg-icon svg-icon-3 ms-2 me-0" }
const _hoisted_16 = {
  key: 1,
  class: "indicator-progress"
}
const _hoisted_17 = /*#__PURE__*/_createElementVNode("span", { class: "spinner-border spinner-border-sm align-middle ms-2" }, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Field = _resolveComponent("Field")!
  const _component_ErrorMessage = _resolveComponent("ErrorMessage")!
  const _component_inline_svg = _resolveComponent("inline-svg")!
  const _component_el_form = _resolveComponent("el-form")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _hoisted_4,
        _createVNode(_component_el_form, {
          onSubmit: _cache[1] || (_cache[1] = _withModifiers(($event: any) => (_ctx.submit()), ["prevent"])),
          model: _ctx.formData,
          rules: _ctx.rules,
          ref: "formRef"
        }, {
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_5, [
              _createElementVNode("div", _hoisted_6, [
                _createElementVNode("div", _hoisted_7, [
                  _hoisted_8,
                  _createVNode(_component_Field, {
                    modelValue: _ctx.trainee.photo,
                    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.trainee.photo) = $event)),
                    name: "photo",
                    ref: "traineeFileInput",
                    onChange: _ctx.traineePhoto,
                    type: "file",
                    class: "form-control"
                  }, null, 8, ["modelValue", "onChange"]),
                  _createElementVNode("div", _hoisted_9, [
                    (_ctx.url)
                      ? (_openBlock(), _createElementBlock("img", {
                          key: 0,
                          src: _ctx.url
                        }, null, 8, _hoisted_10))
                      : _createCommentVNode("", true)
                  ]),
                  _createVNode(_component_ErrorMessage, {
                    name: "trainee_image",
                    class: "fv-plugins-message-container invalid-feedback"
                  })
                ])
              ])
            ]),
            _createElementVNode("div", _hoisted_11, [
              _hoisted_12,
              _createElementVNode("button", {
                "data-kt-indicator": _ctx.loading ? 'on' : null,
                class: "btn btn-lg btn-primary",
                type: "submit"
              }, [
                (!_ctx.loading)
                  ? (_openBlock(), _createElementBlock("span", _hoisted_14, [
                      _createTextVNode(" Submit "),
                      _createElementVNode("span", _hoisted_15, [
                        _createVNode(_component_inline_svg, { src: "icons/duotune/arrows/arr064.svg" })
                      ])
                    ]))
                  : _createCommentVNode("", true),
                (_ctx.loading)
                  ? (_openBlock(), _createElementBlock("span", _hoisted_16, [
                      _createTextVNode(" Please wait... "),
                      _hoisted_17
                    ]))
                  : _createCommentVNode("", true)
              ], 8, _hoisted_13)
            ])
          ]),
          _: 1
        }, 8, ["model", "rules"])
      ])
    ])
  ], 512))
}